module.exports = __webpack_public_path__ + "media/images/cohda/logo-61c14952e8809170a9bdd5cc937feb05.png";